import {Pipe, PipeTransform} from '@angular/core';
import {TtmStatus} from '../classes/ttmstatus';
import {Ttm} from '../classes/ttm';

@Pipe({
    name: 'presentTtmStatuses'
})
export class PresentTtmStatusesPipe implements PipeTransform {

    transform(ttmStatuses: TtmStatus[], ttms: Ttm[], ...args: unknown[]): TtmStatus[] {
        return ttmStatuses.filter(tt => ttms?.filter(ttm => ttm.status_key === tt.key)?.length > 0);
    }

}
